// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stake-report-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.stake-report-summary__card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.stake-report-summary__value {
  display: block;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}

.stake-report-summary__label {
  font-size: 0.82rem;
  color: #64748b;
}

.stake-report-detail-page__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.stake-report-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.86rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid rgba(15, 118, 110, 0.35);
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s;
}

.stake-report-back-btn:hover {
  background: #f0fdfa;
}

.stake-report-detail-page__id {
  font-size: 0.82rem;
  color: #64748b;
}

.stake-report-detail-page__id code {
  font-size: 0.78rem;
  background: #f1f5f9;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
}

.stake-report-detail-page__card {
  padding: 1.25rem;
}

.stake-report-detail-page__meta {
  margin: 1rem 0 0;
  font-size: 0.8rem;
  color: #64748b;
  text-align: right;
}

.stake-report-detail-page__error {
  text-align: center;
  padding: 2rem 1rem;
  color: #64748b;
}

.stake-report-detail-page__error i {
  font-size: 2rem;
  color: #dc2626;
  margin-bottom: 0.75rem;
}

.stake-report-detail-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.stake-report-detail-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border-radius: 12px;
  background: linear-gradient(125deg, #0f766e 0%, #14b8a6 55%, #0d9488 100%);
  color: #fff;
}

.stake-report-detail-hero__eyebrow {
  margin: 0 0 0.25rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.85;
}

.stake-report-detail-hero__title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 700;
}

.stake-report-detail-hero__sub {
  margin: 0;
  font-size: 0.88rem;
  opacity: 0.92;
}

.stake-report-detail-summary-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
}

.stake-report-detail-summary-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.85rem;
}

.stake-report-detail-summary-card__label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.stake-report-detail-summary-card__value {
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
}

@media (max-width: 1024px) {
  .stake-report-detail-summary-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .stake-report-detail-summary-cards {
    grid-template-columns: 1fr;
  }

  .stake-report-detail-hero {
    flex-direction: column;
  }
}

.stake-report-detail-section {
  margin-bottom: 1.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.stake-report-detail-section__title {
  margin: 0;
  padding: 0.65rem 0.85rem;
  font-size: 0.88rem;
  font-weight: 700;
  color: #0f172a;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.stake-report-detail-section__body {
  padding: 0.85rem;
}

.stake-report-kv-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.65rem 1rem;
}

.stake-report-kv {
  font-size: 0.84rem;
}

.stake-report-kv dt {
  margin: 0 0 0.15rem;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
}

.stake-report-kv dd {
  margin: 0;
  color: #0f172a;
  word-break: break-word;
}

.stake-report-table-wrap {
  overflow-x: auto;
}

.stake-report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.stake-report-table th {
  padding: 0.55rem 0.65rem;
  text-align: left;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #f8fafc;
  background: #0f172a;
  white-space: nowrap;
}

.stake-report-table td {
  padding: 0.55rem 0.65rem;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
  vertical-align: top;
}

.stake-report-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.stake-report-level-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
}

.stake-report-level-tab {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
  border-radius: 999px;
  padding: 0.3rem 0.65rem;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}

.stake-report-level-tab--active {
  color: #fff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
}

.stake-report-status {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
}

.stake-report-status--active {
  background: #dcfce7;
  color: #166534;
}

.stake-report-status--completed {
  background: #dbeafe;
  color: #1d4ed8;
}

.stake-report-status--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

.stake-report-status--default {
  background: #f1f5f9;
  color: #475569;
}

.stake-report-paid-badge {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
}

.stake-report-paid-badge--paid {
  background: #dcfce7;
  color: #166534;
}

.stake-report-paid-badge--unpaid {
  background: #fef3c7;
  color: #92400e;
}

@media (max-width: 1024px) {
  .stake-report-summary {
    grid-template-columns: repeat(2, 1fr);
  }

  .stake-report-kv-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .stake-report-summary {
    grid-template-columns: 1fr;
  }

  .stake-report-kv-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Staking/StakingFullReportPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".stake-report-summary {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.stake-report-summary__card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.stake-report-summary__value {\n  display: block;\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.stake-report-summary__label {\n  font-size: 0.82rem;\n  color: #64748b;\n}\n\n.stake-report-detail-page__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.stake-report-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid rgba(15, 118, 110, 0.35);\n  border-radius: 8px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.stake-report-back-btn:hover {\n  background: #f0fdfa;\n}\n\n.stake-report-detail-page__id {\n  font-size: 0.82rem;\n  color: #64748b;\n}\n\n.stake-report-detail-page__id code {\n  font-size: 0.78rem;\n  background: #f1f5f9;\n  padding: 0.15rem 0.4rem;\n  border-radius: 4px;\n}\n\n.stake-report-detail-page__card {\n  padding: 1.25rem;\n}\n\n.stake-report-detail-page__meta {\n  margin: 1rem 0 0;\n  font-size: 0.8rem;\n  color: #64748b;\n  text-align: right;\n}\n\n.stake-report-detail-page__error {\n  text-align: center;\n  padding: 2rem 1rem;\n  color: #64748b;\n}\n\n.stake-report-detail-page__error i {\n  font-size: 2rem;\n  color: #dc2626;\n  margin-bottom: 0.75rem;\n}\n\n.stake-report-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.stake-report-detail-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.1rem;\n  border-radius: 12px;\n  background: linear-gradient(125deg, #0f766e 0%, #14b8a6 55%, #0d9488 100%);\n  color: #fff;\n}\n\n.stake-report-detail-hero__eyebrow {\n  margin: 0 0 0.25rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  opacity: 0.85;\n}\n\n.stake-report-detail-hero__title {\n  margin: 0 0 0.35rem;\n  font-size: 1.35rem;\n  font-weight: 700;\n}\n\n.stake-report-detail-hero__sub {\n  margin: 0;\n  font-size: 0.88rem;\n  opacity: 0.92;\n}\n\n.stake-report-detail-summary-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.75rem;\n}\n\n.stake-report-detail-summary-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.85rem;\n}\n\n.stake-report-detail-summary-card__label {\n  display: block;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin-bottom: 0.25rem;\n}\n\n.stake-report-detail-summary-card__value {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n@media (max-width: 1024px) {\n  .stake-report-detail-summary-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .stake-report-detail-summary-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .stake-report-detail-hero {\n    flex-direction: column;\n  }\n}\n\n.stake-report-detail-section {\n  margin-bottom: 1.25rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.stake-report-detail-section__title {\n  margin: 0;\n  padding: 0.65rem 0.85rem;\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: #0f172a;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.stake-report-detail-section__body {\n  padding: 0.85rem;\n}\n\n.stake-report-kv-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.65rem 1rem;\n}\n\n.stake-report-kv {\n  font-size: 0.84rem;\n}\n\n.stake-report-kv dt {\n  margin: 0 0 0.15rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #64748b;\n}\n\n.stake-report-kv dd {\n  margin: 0;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.stake-report-table-wrap {\n  overflow-x: auto;\n}\n\n.stake-report-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n\n.stake-report-table th {\n  padding: 0.55rem 0.65rem;\n  text-align: left;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #f8fafc;\n  background: #0f172a;\n  white-space: nowrap;\n}\n\n.stake-report-table td {\n  padding: 0.55rem 0.65rem;\n  border-bottom: 1px solid #e2e8f0;\n  color: #1e293b;\n  vertical-align: top;\n}\n\n.stake-report-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.stake-report-level-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-bottom: 0.75rem;\n}\n\n.stake-report-level-tab {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n  border-radius: 999px;\n  padding: 0.3rem 0.65rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.stake-report-level-tab--active {\n  color: #fff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n}\n\n.stake-report-status {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.stake-report-status--active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.stake-report-status--completed {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.stake-report-status--cancelled {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.stake-report-status--default {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.stake-report-paid-badge {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.stake-report-paid-badge--paid {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.stake-report-paid-badge--unpaid {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n@media (max-width: 1024px) {\n  .stake-report-summary {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .stake-report-kv-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .stake-report-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .stake-report-kv-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
